import { getCurrentDatabase } from '../../utils/companyUtils';

// ─── Helpers de rol_metric ────────────────────────────────────
const getCurrentUserRolMetric = () => {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const parsed = JSON.parse(raw);
      return parsed.rol_metric_name || null;
    }
  } catch {
    /* ignore */
  }
  return null;
};

const getCurrentUserRemitos = () => {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const parsed = JSON.parse(raw);
      return parsed.remitos === 1 || parsed.remitos === true;
    }
  } catch { /* ignore */ }
  return false;
};

const getCurrentUserEmail = () => {
  try {
    const raw = localStorage.getItem('user');
    if (raw) return JSON.parse(raw).email || '';
  } catch { /* ignore */ }
  return '';
};

// Secciones visibles por rol (solo aplica cuando isDOW)
const ROLE_SECTIONS = {
  'maestro': ['home', 'imports', 'exports', 'mro', 'dispatches', 'remitos', 'tools'],
  'general': ['home', 'imports', 'exports', 'mro', 'dispatches'],
  'import': ['home', 'imports'],
  'import admin': ['home', 'imports', 'tools'],
  export: ['home', 'exports'],
  'export admin': ['home', 'exports', 'tools'],
  mro: ['home', 'mro'],
  'mro admin': ['home', 'mro', 'tools'],
  'remitos': ['home', 'remitos'],
  'appo': ['home', 'appo'],
};

// Función que genera el menú dinámicamente - se ejecuta cada vez que se llama
const getMenuData = () => {
  const currentDatabase = getCurrentDatabase();
  const isDOW = currentDatabase === 'ssb_internacional';
  const rolMetric = getCurrentUserRolMetric();
  const userHasRemitos = getCurrentUserRemitos();
  const userEmail = getCurrentUserEmail();

  // Devuelve true si el usuario puede ver la sección dada
  const canSee = (section) => {
    if (!isDOW) return true; // sin DOW: sin restricciones de rol
    if (section === 'remitos' && userHasRemitos) return true; // acceso explícito por flag
    if (!rolMetric) return true; // sin rol asignado: ve todo
    const allowed = ROLE_SECTIONS[rolMetric.toLowerCase()];
    if (!allowed) return true; // rol desconocido: ve todo
    return allowed.includes(section);
  };

  console.log(
    'Menu generation - Current Database:',
    currentDatabase,
    'isDOW:',
    isDOW,
    'rolMetric:',
    rolMetric
  );

  return [
    ...(canSee('home')
      ? [
        {
          text: 'Home',
          link: '/',
          icon: 'home',
        },
      ]
      : []),
    ...(canSee('imports')
      ? [
        {
          text: 'Imports',
          subMenu: [
            {
              text: 'Follow - UP',
              link: '/listplasticos',
            },
            {
              text: 'Follow-Reports',
              link: '/followup',
            },
            {
              text: 'New Orders',
              link: '/muestras',
            },

            ...(isDOW
              ? [
                {
                  text: 'Gestor',
                  link: '/dashboardImpoGestor',
                },
                {
                  text: 'Trasbordos',
                  link: '/trasbordos',
                },
                {
                  text: 'Cargoes',
                  link: '/cargoes-ordenes',
                },
                {
                  text: 'Automatizations',
                  subMenu: [
                    {
                      text: 'Documents',
                      link: '/automatizations-gestor-import',
                    },
                    {
                      text: 'Envio Fup',
                      link: '/ssb-reports-dashboard',
                    },
                    {
                      text: 'Updates APIs',
                      link: '/automatic-updates',
                    },
                  ],
                },
                {
                  text: 'APPO',
                  subMenu: [
                    {
                      text: 'Isotank To Clean - Pendientes',
                      link: '/isotank-management',
                    },
                    {
                      text: 'Isotank To Clean - Gestion',
                      link: '/dashboardAppo',
                    },
                    {
                      text: 'Isotank Shipper Own Gestion',
                      link: '/isotank-shipper-own-gestion',
                    },
                    {
                      text: 'Isotank Demurrage',
                      link: '/isotank-demurrage',
                    },
                    {
                      text: 'Cylinders Shiper Own - Temporary Admission',
                      link: '/cilinder-temporary-admission',
                    },
                    {
                      text: 'Gestión de Mails APPO',
                      link: '/gestion-mails',
                    },
                  ],
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    ...(canSee('exports')
      ? [
        {
          text: 'Exports',
          subMenu: [
            {
              text: 'Follow - UP',
              link: '/followUpExpo',
            },
            {
              text: 'DB Master',
              link: '/expo/master-db',
            },
            ...(isDOW
              ? [
                {
                  text: 'Export Benefits',
                  link: '/dashboardExpoBenefits',
                },
                {
                  text: 'Automatizations',
                  subMenu: [
                    {
                      text: 'Documents',
                      link: '/automatizations-gestor-expo',
                    },
                  ],
                },
                {
                  text: 'Gestor',
                  link: '/dashboardExpoGestor',
                },
                {
                  text: '315 - Global',
                  link: '/gestor-315',
                },
                {
                  text: 'Updates Globales',
                  link: '/updates-globales',
                },
                {
                  text: 'MacroUpdate',
                  link: '/macroUpdate',
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    ...(isDOW && canSee('mro')
      ? [
        {
          text: 'MRO',
          subMenu: [
            {
              text: 'Temporales',
              link: '/temporalesMro',
            },
            {
              text: 'Payments Upload',
              link: '/mro-payments-upload',
            },
            {
              text: 'Subida Docs',
              link: '/mro/subida-docs',
            },
            {
              text: 'Subida Remitos',
              link: '/mro/remitos/subida',
            },
            {
              text: 'Automatizaciones',
              subMenu: [
                {
                  text: 'Remitos',
                  link: '/mro/automatizaciones/remitos',
                },
              ],
            },
            {
              text: 'Reporte Acciones',
              link: '/mro/acciones',
            },
          ],
        },
      ]
      : []),

    ...(isDOW && canSee('dispatches') ? [{
      text: 'Dispatches',
      subMenu: [
        {
          text: 'Dispatches Query',
          link: 'interlogApi',
        },
      ]
    }] : []),
    ...(isDOW && canSee('appo') ? [{
      text: 'APPO',
      subMenu: [
        {
          text: 'Isotank To Clean - Pendientes',
          link: '/isotank-management',
        },
        {
          text: 'Isotank To Clean - Gestion',
          link: '/dashboardAppo',
        },
        {
          text: 'Isotank Shipper Own Gestion',
          link: '/isotank-shipper-own-gestion',
        },
        {
          text: 'Cylinders Shiper Own - Temporary Admission',
          link: '/cilinder-temporary-admission',
        }       
      ],
    }] : []),
    /*...(isDOW && canSee('remitos') ? [{
      text: 'Remitos',
      subMenu: [
        {
          text: 'Altas',
          link: '/remitos/altas',
        },
        {
          text: 'Listado',
          link: '/remitos/listado',
        },
        {
          text: 'Configuración',
          link: '/remitos/configuracion',
        },
        ...(userEmail.includes('@ssbint') ? [{
          text: 'Alertas',
          link: '/remitos/alertas',
        }] : []),
      ]
    }] : []),*/
    ...(isDOW && canSee('tools') ? [{
      text: 'Tools',
      subMenu: [
        {
          text: 'Cargo Routes',
          link: '/cargoRoutes',
        },
        {
          text: 'JSON 304',
          link: '/json-304',
        },

        {
          text: 'Usuarios, Permisos & Gestion',
          subMenu: [
            {
              text: 'Users & Permissions',
              link: '/users-admin',
            },
            {
              text: 'Mantenimiento & Gestion',
              link: '/gestion',
            },
            {
              text: 'Transportation Method',
              link: '/transportation-method',
            },
          ]
        },
        /*{
          text: 'Dow Dashboard',
          link: '/dow-dashboard',
        },
        {
          text: 'Permits Dashboard',
          link: '/permits-dashboard',
        },*/
        {
          text: 'Alertas Operativas',
          link: '/ops-alertas',
        },
        {
          text: 'Issues & Projects',
          link: '/project-tracker',
        },
        {
          text: 'Prefolder',
          subMenu: [
            {
              text: 'Config',
              link: '/prefolder-config',
            },
            {
              text: 'Audit Log',
              link: '/prefolder-audit',
            },
          ]
        },
        {
          text: 'Temp. Admission Fup.',
          subMenu: [
            {
              text: 'Seriales de Cilindros',
              link: '/seriales-cilindros',
            },
            {
              text: 'Temporales',
              link: '/temporales',
            },
            {
              text: 'Transitos',
              link: '/transitos',
            },
            {
              text: 'Consumos',
              link: '/consumo-transitos',
            },
          ]
        },
        {
          text: 'Gestion RET',
          subMenu: [
            {
              text: 'Gestor',
              link: '/gestion-ret',
            },
            {
              text: 'Bots',
              link: '/bots',
            }
          ]
        },
        {
          text: 'Automatizaciones',
          link: '/importer-automatizaciones',
        },
      ],
    }] : []),
  ];
};

// Crear un array que se regenera automáticamente cuando se accede
const createDynamicMenu = () => {
  let cachedMenu = null;
  let lastDatabase = null;
  let lastRolMetric = undefined;
  let lastRemitos = undefined;

  const updateMenuIfNeeded = () => {
    const currentDatabase = getCurrentDatabase();
    const currentRolMetric = getCurrentUserRolMetric();
    const currentRemitos = getCurrentUserRemitos();
    if (currentDatabase !== lastDatabase || currentRolMetric !== lastRolMetric || currentRemitos !== lastRemitos) {
      console.log('Menu update triggered - Database changed from', lastDatabase, 'to', currentDatabase, '/ Role:', lastRolMetric, '->', currentRolMetric);
      cachedMenu = getMenuData();
      lastDatabase = currentDatabase;
      lastRolMetric = currentRolMetric;
      lastRemitos = currentRemitos;
    }
    return cachedMenu || getMenuData();
  };

  // Crear un array real que se actualiza automáticamente
  const dynamicArray = [];

  // Interceptar accesos al array para regenerarlo si es necesario
  return new Proxy(dynamicArray, {
    get(target, prop) {
      const menu = updateMenuIfNeeded();

      // Propiedades especiales de array
      if (prop === 'length') return menu.length;
      if (prop === Symbol.iterator)
        return menu[Symbol.iterator].bind(menu);
      if (prop === 'map') return menu.map.bind(menu);
      if (prop === 'forEach') return menu.forEach.bind(menu);
      if (prop === 'filter') return menu.filter.bind(menu);
      if (prop === 'find') return menu.find.bind(menu);
      if (prop === 'slice') return menu.slice.bind(menu);
      if (prop === 'concat') return menu.concat.bind(menu);

      // Índices numéricos
      if (typeof prop === 'string' && !isNaN(prop)) {
        return menu[parseInt(prop)];
      }

      // Cualquier otra propiedad
      return menu[prop];
    },

    ownKeys() {
      const menu = updateMenuIfNeeded();
      return Object.keys(menu);
    },

    getOwnPropertyDescriptor(target, prop) {
      const menu = updateMenuIfNeeded();
      return Object.getOwnPropertyDescriptor(menu, prop);
    },
  });
};

export default createDynamicMenu();
